import { BankDetailsResponse } from '~domains/partner-application/entities/application';
import { useDisbursementProviders } from '~domains/partner-application/entities/disbursement-providers';
import { Card } from '~domains/partner-application/shared/ui/card';

import { DocumentReviewItem } from './document-review-item';
import { ReviewItem } from './review-item';

type BankAccountReviewProps = {
  bankDetails: BankDetailsResponse | undefined;
  onEdit?: () => void;
};

export const BankAccountReview = ({
  bankDetails,
  onEdit,
}: BankAccountReviewProps) => {
  const { data: providers } = useDisbursementProviders();

  if (!bankDetails) {
    return null;
  }

  const provider = providers?.find(
    (provider) => provider.id === bankDetails.providerId
  );

  return (
    <Card header="Bank account info" onEdit={onEdit}>
      <div className="grid grid-cols-2 gap-4">
        <ReviewItem title="Bank" value={provider?.brand.name} />
        <ReviewItem
          title="Bank Account Name"
          value={bankDetails.beneficiaryName}
        />
        <ReviewItem
          title="Bank Account Number"
          value={bankDetails.accountNumber}
        />
        {!!bankDetails.proofsOfAccount?.length && (
          <div className="col-span-full flex flex-col gap-3">
            {bankDetails.proofsOfAccount.map((document) => (
              <DocumentReviewItem
                key={document.documentId}
                title="Proof of Bank Account"
                document={document}
              />
            ))}
          </div>
        )}
      </div>
    </Card>
  );
};
